<div class="ibox">
  <div class="ibox-content" >
    <div class="row">
      <div class="col-lg">
        <div class="tabs-container">
          <div id="tabGeneral" #tabGeneral class="">
            <ul class="nav nav-tabs">
              <li class="active"><a class="nav-link tab-parent" data-toggle="tab" (click)="changeTab(tabGeneral, 0)">Datos Básicos</a></li>
              <li><a class="nav-link tab-parent" data-toggle="tab" (click)="changeTab(tabGeneral, 1)">Datos de Nomina</a></li>
              <li><a class="nav-link tab-parent" data-toggle="tab" (click)="changeTab(tabGeneral, 2)">Datos de Tiempos</a></li>
              <li><a class="nav-link tab-parent" data-toggle="tab" (click)="changeTab(tabGeneral, 3)">Datos Legales</a></li>
            </ul>
            <div class="tab-content sub-tabs">
              <div id="tab-1" class="tab-pane active sub-tabs">
                <div class="panel-body tabs-principal">
                  <div class="tabs-container" id="tabBasicos" #tabBasicos>
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="active"><a *ngIf="permisoPersonal" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 0)">Datos Personales</a></li>
                      <li><a *ngIf="permisoOrganizativo && componente12?.cargaCompleta" class="nav-link" data-toggle="tab"  (click)="changeTab(tabBasicos, 1)">Datos Organizativos</a></li>
                      <li><a *ngIf="permisoDireccion && componente13?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 2)">Direcciones</a></li>
                      <li><a *ngIf="permisoFamiliar && componente14?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 3)">Familiares</a></li>
                      <li><a *ngIf="permisoIdentidad && componente15?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 4)">Info Identidad</a></li>
                      <li><a *ngIf="permisoFecha && componente16?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 5)">Datos Fechas</a></li>
                      <li><a *ngIf="permisoAfiliacion && componente17?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 6)">Afiliaciones</a></li>
                      <li><a *ngIf="permisoContrato && componente18?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabBasicos, 7)">Contratos</a></li>
                    </ul>
                    <div class="tab-content sub-tabs">
                      <div id="tab-11" class="tab-pane active">
                        <div class="tab-top panel-body" *ngIf="permisoPersonal">
                          <app-datos-personales [personalRelacion]="personal"
                                                [legajo]="personal?.legajo"
                                                [personalId]="personal?.id"
                                                [idfiscal]="personal?.idfiscal"
                                                [fechaNacimiento]="personal?.fechaNacimiento"
                                                [nacionalidad]="personal?.nacionalidadNavigation"
                                                [idioma]="personal?.idiomaNavigation"
                                                (CargarHijo11)="OnCargarHijo11()">
                          </app-datos-personales>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-12" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoOrganizativo">
                          <app-datos-organizativos [legajo]="personal?.legajo"
                                                   [personalId]="personal?.id"
                                                   [fechaslist]="fechaslist"
                                                   [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-datos-organizativos>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-13" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoDireccion">
                          <app-direcciones   [legajo]="personal?.legajo"
                                             [personalId]="personal?.id"
                                             [fechaslist]="fechaslist"
                                             [gruposLiquidaciones]="gruposLiquidaciones"
                                             [personal]="personal">
                          </app-direcciones>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-14" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoFamiliar">
                          <app-familiares   [legajo]="personal?.legajo"
                                            [personalId]="personal?.id"
                                            [fechaslist]="fechaslist"
                                            [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-familiares>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-15" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoIdentidad">
                          <app-info-identidad-cab [legajo]="personal?.legajo" 
                                                  [personalId]="personal?.id"
                                                  [fechaslist]="fechaslist"
                                                  [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-info-identidad-cab>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-16" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoFecha">
                          <app-datos-fechas-cab [legajo]="personal?.legajo"
                                                [personalId]="personal?.id"
                                                [fechaslist]="fechaslist"
                                                [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-datos-fechas-cab>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-17" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoAfiliacion">
                          <app-afiliaciones-cab  [legajo]="personal?.legajo"
                                              [personalId]="personal?.id"
                                              [fechaslist]="fechaslist"
                                              [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-afiliaciones-cab>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-18" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoContrato">
                          <app-contratos   [legajo]="personal?.legajo"
                                            [personalId]="personal?.id"
                                            [fechaslist]="fechaslist"
                                            [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-contratos>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="tab-2" class="tab-pane sub-tabs">
                <div class="panel-body tabs-principal">
                  <div class="tabs-container" #tabNomina>
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="active"><a *ngIf="permisoBanco && componente21?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 0)">Datos Bancarios</a></li>
                      <li><a *ngIf="permisoSueldo && componente22?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 1)">Sueldo Básico</a></li>
                      <li><a *ngIf="permisoNovFija && componente23?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 2)">Novedades Fijas</a></li>
                      <li><a *ngIf="permisoNovPeriodo && componente24?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 3)">Novedades Período</a></li>
                      <li><a *ngIf="permisoNomina && componente25?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 4)">Estado Nómina</a></li>
                      <li><a *ngIf="permisoNomEspeciales && componente26?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 5)">Nóminas Especiales</a></li>
                      <li><a *ngIf="permisoIndemnizacion && componente27?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabNomina, 6)">Indemnización</a></li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" id="tab-21" class="tab-pane active">
                        <div class="panel-body" *ngIf="permisoBanco">
                          <app-datos-banco   [legajo]="personal?.legajo"
                                            [personalId]="personal?.id"
                                            [fechaslist]="fechaslist"
                                            [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-datos-banco>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-22" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoSueldo">
                          <app-sueldo   [legajo]="personal?.legajo"
                                        [personalId]="personal?.id"
                                        [fechaslist]="fechaslist"
                                        [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-sueldo>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-23" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoNovFija">
                          <app-novedades-mes   [legajo]="personal?.legajo"
                                                [personalId]="personal?.id"
                                                [fechaslist]="fechaslist"
                                                [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-novedades-mes>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-24" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoNovPeriodo">
                          <app-novedades-periodo   [legajo]="personal?.legajo"
                                                    [personalId]="personal?.id"
                                                    [fechaslist]="fechaslist"
                                                    [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-novedades-periodo>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-25" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoNomina">
                          <app-datos-estado-nomina 
                                            [personalRelacion]="personal"
                                            [legajo]="personal?.legajo">
                          </app-datos-estado-nomina>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-26" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoNomEspeciales">
                          <app-nominas-especiales   [legajo]="personal?.legajo"
                                                    [personalId]="personal?.id"
                                                    [fechaslist]="fechaslist"
                                                    [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-nominas-especiales>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-27" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoIndemnizacion">
                          <app-indemnizacion  [legajo]="personal?.legajo"
                                              [personalId]="personal?.id"
                                              [fechaslist]="fechaslist"
                                              [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-indemnizacion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="tab-3" class="tab-pane sub-tabs">
                <div class="panel-body tabs-principal">
                  <div class="tabs-container" #tabTiempos>
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="active"><a *ngIf="permisoHorario && componente31?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabTiempos, 0)">Horarios de Trabajo</a></li>
                      <li><a *ngIf="permisoNovTiempo && componente32?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabTiempos, 1)">Novedades Tiempos</a></li>
                      <li><a *ngIf="permisoAusentismo && componente33?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabTiempos, 2)">Ausentismos</a></li>
                      <li><a *ngIf="permisoContingente && componente34?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabTiempos, 3)">Contingentes</a></li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" id="tab-31" class="tab-pane active">
                        <div class="panel-body sub-tabs" *ngIf="permisoHorario">
                          <app-horarios-trabajo   [legajo]="personal?.legajo"
                                                  [personalId]="personal?.id"
                                                  [fechaslist]="fechaslist"
                                                  [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-horarios-trabajo>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-32" class="tab-pane ">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoNovTiempo">
                          <app-novedades-tiempos [legajo]="personal?.legajo"
                                                 [personalId]="personal?.id"
                                                 [fechaslist]="fechaslist"
                                                 [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-novedades-tiempos>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-33" class="tab-pane ">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoAusentismo">
                          <app-ausentismos-cab [legajo]="personal?.legajo"
                                               [personalId]="personal?.id"
                                               [fechaslist]="fechaslist"
                                               [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-ausentismos-cab>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-34" class="tab-pane ">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoContingente">
                          <app-contingentes-cab [legajo]="personal?.legajo"
                                                [personalId]="personal?.id"
                                                [fechaslist]="fechaslist"
                                                [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-contingentes-cab>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="tab-4" class="tab-pane sub-tabs">
                <div class="panel-body tabs-principal">
                  <div class="tabs-container" #tabLegales>
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="active"><a *ngIf="permisoDatosIIGG && componente41?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabLegales, 0)">Datos IIGG</a></li>
                      <li><a *ngIf="permisoDeduccionesIIGG && componente42?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabLegales, 1)">Deducciones IIGG</a></li>
                      <li><a *ngIf="permisoOtroEmpleador && componente43?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabLegales, 2)">Otro Empleador</a></li>
                      <li><a *ngIf="permisoSeguridadSocial && componente44?.cargaCompleta" class="nav-link" data-toggle="tab" (click)="changeTab(tabLegales, 3)">Seguridad Social</a></li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" id="tab-41" class="tab-pane active">
                        <div class="panel-body sub-tabs" *ngIf="permisoDatosIIGG">
                          <app-datos-iigg   [legajo]="personal?.legajo"
                                            [personalId]="personal?.id"
                                            [fechaslist]="fechaslist"
                                            [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-datos-iigg>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-42" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoDeduccionesIIGG">
                          <app-deduciones-iigg  [legajo]="personal?.legajo"
                                                [personalId]="personal?.id"
                                                [fechaslist]="fechaslist"
                                                [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-deduciones-iigg>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-43" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoOtroEmpleador">
                          <app-otro-empleador  [legajo]="personal?.legajo"
                                               [personalId]="personal?.id"
                                               [fechaslist]="fechaslist"
                                               [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-otro-empleador>
                        </div>
                      </div>
                      <div role="tabpanel" id="tab-44" class="tab-pane">
                        <div class="tab-top panel-body sub-tabs" *ngIf="permisoSeguridadSocial">
                          <app-seguridad-social  [legajo]="personal?.legajo"
                                                 [personalId]="personal?.id"
                                                 [fechaslist]="fechaslist"
                                                 [gruposLiquidaciones]="gruposLiquidaciones">
                          </app-seguridad-social>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

